export default "__VITE_ASSET__ee59eba7__"